<template>
  <div class="flex flex-col justify-between border rounded p-3 bg-white">
    <div class="mb-10">
      <img
        v-if="item.image"
        :src="getImageUrl(item.image.key, item.image.filename, 474, 354)"
        width="474"
        height="354"
        :alt="item.productLineName"
        class="mb-4"
      />
      <div class="space-y-3">
        <p class="text-lg font-bold">
          <InlineHtml :text="item.productLineName" />
        </p>

        <p v-if="item.fitmentData && item.fitmentData.year" class="text-sm">
          {{ item.fitmentData.year }} {{ item.fitmentData.makeName }} {{ item.fitmentData.modelName }}
          <template v-if="item.fitmentData.bedName">
            &nbsp;
            <InlineHtml :text="item.fitmentData.bedName" />
          </template>

          <template v-if="item.fitmentData.bodyName">
            &nbsp;
            <InlineHtml :text="item.fitmentData.bodyName" />
          </template>

          <template v-if="item.fitmentData.engineName">
            &nbsp;
            <InlineHtml :text="item.fitmentData.engineName" />
          </template>

          <template v-if="item.fitmentData.appNote">
            &nbsp;
            <InlineHtml :text="item.fitmentData.appNote" />
          </template>
        </p>

        <div
          class="text-2xl font-bold pt-1"
          :class="[item.salePrice === item.originalPrice ? 'text-black' : 'text-danger']"
        >
          {{ formatCents(item.salePrice) }}
        </div>
      </div>
    </div>

    <div class="flex gap-x-3">
      <BaseButton
        color="GRAY_LIGHT"
        button-style="OUTLINE"
        has-custom-text-color
        has-custom-padding
        class="flex-1 text-dark py-3 px-1"
        :is-waiting="isLoading"
        @click="moveToCart"
      >
        Move to cart
      </BaseButton>

      <BaseButton
        color="GRAY_LIGHT"
        button-style="OUTLINE"
        class="text-dark px-3"
        has-custom-text-color
        has-custom-padding
        :is-waiting="isLoading"
        @click="removeFromWishlist"
      >
        <img src="/images/trashIcon.svg" alt="trash icon" class="w-6 h-6" loading="lazy" />
      </BaseButton>
    </div>
  </div>
</template>

<script setup lang="ts">
const wishlist = useWishlist()
const notifications = useNotifications()
const { $uiEvents, $scrollTo } = useNuxtApp()
const { getImageUrl } = useUrls()

const { item } = defineProps<{
  item: CartItem
}>()

const isLoading = ref(false)

async function moveToCart() {
  if (isLoading.value) return

  isLoading.value = true

  try {
    await wishlist.moveToCart(item)
    notifications.addSuccess('Added to cart', `${item.productLineName} has been moved to the cart!`)
    $uiEvents.$emit('saveForLaterMoved', item)

    // After successful move, scroll user back up the the top of the cart
    $scrollTo('#cart', 500)
  } catch (error) {
    notifications.addError('Error', `Unable to move item. Please try again later.`)
  }

  isLoading.value = false
}

async function removeFromWishlist() {
  if (isLoading.value) return

  isLoading.value = true

  try {
    await wishlist.removeFromWishlist(item.id)
    $uiEvents.$emit('saveForLaterDeleted', item)
  } catch (error) {
    notifications.addError('Error', `Unable to delete item from the list. Please try again later.`)
  }

  isLoading.value = false
}
</script>
